import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProvider } from './context/AppContext';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode temporarily disabled: its dev-only double-mount races with
  // Stripe CardElement's iframe init and causes unstyled/duplicated fields.
  // Restore <React.StrictMode> once Stripe UI work is done.
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <AppProvider>
      <App />
    </AppProvider>
  </GoogleOAuthProvider>
);

